
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule, MatDialogModule, MatExpansionModule } from '@angular/material';
import { FormModule } from '../form/form.module';
import { SharedModule } from '../../shared/shared.module';
import { BasicRegistrationComponent } from '../registration/components/basic-registration/basic-registration.component';




@NgModule({
    imports: [
        CommonModule,
        MatInputModule,
        MatDialogModule,
        MatExpansionModule,
        SharedModule,
        FormModule
    ],
    declarations: [
        BasicRegistrationComponent
    ],
    exports: [
        BasicRegistrationComponent
    ],
    providers: [],
    entryComponents: []
})
export class RegistrationModule { }
